import _toConsumableArray from "/Users/francescovezzoli/Desktop/Appius/cpiaassessment/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export default function arrayShuffle(array) {
  if (!Array.isArray(array)) {
    throw new TypeError("Expected an array, got ".concat(typeof array));
  }

  array = _toConsumableArray(array);

  for (var index = array.length - 1; index > 0; index--) {
    var newIndex = Math.floor(Math.random() * (index + 1));
    var _ref = [array[newIndex], array[index]];
    array[index] = _ref[0];
    array[newIndex] = _ref[1];
  }

  return array;
}